<template>
  <div>
    <MediaLibrary
      ref="mediaLibrary"
      :height="editLayer.height"
      @select-image="selectImage"
      ></MediaLibrary>
  <v-list flat>
    <v-subheader>Layers</v-subheader>
    <v-list-item-group
      color="primary"
    >
      <div
        v-for="(item, i) in layers"
        :key="i"
      >
        <v-list-item
          @click="$emit('activate-layer', i)"
        >
          <v-list-item-icon>
            <v-icon v-text="iconForType(item.type)"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div  v-if="selectedItem == i" class="layer-edit">
          <fieldset>
            <legend>Einstellungen</legend>
            <v-text-field
              v-model="editLayer.name"
              label="Name"
              required
            ></v-text-field>
            <div v-if="editLayer.type === 'title'">
            <v-textarea
              v-model="editLayer.value"
              label="Text"
              required
              auto-grow
              rows="1"
            ></v-textarea>
              <v-row>
                <v-col cols=6>
                  <v-select
                    v-model="editLayer.font"
                    label="Schrift"
                    :items="['Roboto', 'Underdog', 'Playwrite MX Guides']"
                  />
                </v-col>
                <v-col cols=6>
                  <v-dialog
                    ref="colorDialog"
                    v-model="colorModal"
                    persistent
                    width="310px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editLayer.color"
                        label="Farbe"
                        required
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        ></v-text-field>
                    </template>
                    <v-card>
                      <v-card-title>
                        Farbe wählen
                      </v-card-title>
                    <v-card-text>

                    <v-color-picker
                      dot-size="10"
                      mode="rgba"
                      v-model="editLayer.color"
                      swatches-max-height="200"
                    ></v-color-picker>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        @click="colorModal = false"
                      >
                      Ok
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols=6>
                  <v-text-field
                    v-model="editLayer.fontSize"
                    label="Grösse"
                    required
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols=6>
                  <v-text-field
                    v-model="editLayer.lineHeight"
                    label="Zeilenabstand"
                    required
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols=6>
              <v-btn-toggle v-model="editLayer.alignment">
                <v-btn value="left">
                  <v-icon>mdi-format-align-left</v-icon>
                </v-btn>

                <v-btn value="center">
                  <v-icon>mdi-format-align-center</v-icon>
                </v-btn>

                <v-btn value="right">
                  <v-icon>mdi-format-align-right</v-icon>
                </v-btn>

                <v-btn value="justify">
                  <v-icon>mdi-format-align-justify</v-icon>
                </v-btn>
              </v-btn-toggle>
              </v-col>
              <v-col cols=6>
              <v-btn-toggle
                color="primary"
                multiple
                v-model="fontstyles"
              >
                <v-btn>
                  <v-icon>mdi-format-bold</v-icon>
                </v-btn>

                <v-btn>
                  <v-icon>mdi-format-italic</v-icon>
                </v-btn>

                <v-btn>
                  <v-icon>mdi-format-underline</v-icon>
                </v-btn>

              </v-btn-toggle>
              </v-col>
              </v-row>
              <v-row>
                <v-col cols=4>
                  <v-checkbox
                    v-model="shadow"
                    label="Schatten"
                    hide-details
                    color="primary"
                  ></v-checkbox>
                </v-col>
                <v-col cols=8>
                  <v-text-field
                      v-model="editLayer.shadowStyle"
                      label="Schattenstyl"
                      required
                      :disabled="!editLayer.shadow"
                    ></v-text-field>
                </v-col>
              </v-row>
              <v-select
                v-model="editLayer.animation"
                label="Animation"
                :items="animations"
                item-text="name"
                item-value="value"
                clearable
                ></v-select>
            </div>
          </fieldset>
          <div v-if="editLayer.type === 'alertbox'">
            <v-btn
                color="primary"
                class="mt-2 mb-2"
                @click="addAlert"
                >Neuer Alert erfassen</v-btn>
            <fieldset v-for="(alert, j) in editLayer.alerts" :key="j">
              <v-text-field
                  v-model="alert.name"
                  label="Name"
                  required
                ></v-text-field>
              <v-select
                  v-model="alert.type"
                  label="Typ"
                  :items="alertTypes.filter((type) => !editLayer.alerts.some(a => a.type === type.value && a.id !== alert.id))"
                  item-text="name"
                  item-value="value"
                />
                <div style="display: flex; gap: 10px; margin-top: 10px; margin-bottom: 10px;">
                  <div class="preview">
                    <img :src="getImage(alert)" v-if="hasImage(alert)" alt="preview" />
                    <img src="/alerts/default.gif" v-else alt="preview" />
                  </div>
                  <div>
                  <v-btn
                    @click="selectImage(alert)"
                    color="primary"
                    >Bild {{ getImageVerb(alert)}}</v-btn>
                    <br />
                    <br />
                  <v-btn
                    color="primary"
                    @click="selectVideo(alert)"
                    >Video {{ getVideoVerb(alert)}}</v-btn>
                  </div>
                </div>
                <v-slider
                  v-if="hasVideo(alert)"
                  v-model="alert.videovolume"
                  label="Lautstärke Video"
                  max="100"
                  min="0"
                >
                  <template v-slot:append>
                    <v-text-field
                      v-model="alert.videovolume"
                      class="mt-0 pt-0"
                      type="number"
                      style="width: 60px"
                    ></v-text-field>
                  </template>
                </v-slider>
                <v-slider
                  v-if="hasAudio(alert)"
                  v-model="alert.audiovolume"
                  label="Lautstärke Audio"
                  max="100"
                  min="0"
                >
                  <template v-slot:append>
                    <v-text-field
                      v-model="alert.audiovolume"
                      class="mt-0 pt-0"
                      type="number"
                      style="width: 60px"
                    ></v-text-field>
                  </template>
                </v-slider>

                <v-btn
                  color="error"
                  @click="editLayer.alerts.splice(j, 1)"
                  >Löschen</v-btn>

            </fieldset>

          </div>

          <fieldset>
            <legend>Position / Grösse</legend>
            <v-form
              ref="form"
              lazy-validation
            >
              <v-text-field
                v-model="editLayer.width"
                label="Breite"
                required
              ></v-text-field>
              <v-text-field
                v-model="editLayer.height"
                label="Höhe"
                required
              ></v-text-field>
              <v-text-field
                v-model="editLayer.x"
                label="Position X"
                required
              ></v-text-field>
              <v-text-field
                v-model="editLayer.y"
                label="Position Y"
                required
              ></v-text-field>
              <v-slider
                v-model="editLayer.rotation"
                label="Rotation"
                max="360"
                min="-360"
              >
              <template v-slot:append>
                <v-text-field
                  v-model="editLayer.rotation"
                  class="mt-0 pt-0"
                  type="number"
                  style="width: 60px"
                ></v-text-field>
              </template>
              </v-slider>
              <v-slider
                  v-model="editLayer.opacity"
                  label="Deckkraft"
                max="100"
                min="0"
              >
              <template v-slot:append>
                <v-text-field
                  v-model="editLayer.opacity"
                  class="mt-0 pt-0"
                  type="number"
                  style="width: 60px"
                ></v-text-field>
              </template>
            </v-slider>
            </v-form>
          </fieldset>
          <fieldset>
            <legend>Die Gefahrenzone!</legend>
            <v-btn
              color="error"
              @click="checkDelete"
              >Löschen</v-btn>
          </fieldset>
        </div>
      </div>
    </v-list-item-group>
  </v-list>
  <v-dialog
    v-model="deleteDialog"
    width="500"
  >
    <v-card>
      <v-card-title class="text-h5">
        Löschen
      </v-card-title>

      <v-card-text>
        Bist Du sicher dass Du den Layer <b>"{{editLayer.name}}"</b> löschen willst?
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="error"
          text
          @click="doDeleteLayer"
        >
          Ja, weg damit!
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="deleteDialog = false"
        >
          Nee, lass mal gut sein
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import MediaLibrary from './MediaLibrary.vue';

export default {
  name: 'OverlayListComponent',
  components: {
    MediaLibrary,
  },
  props: {
    layers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      colorModal: false,
      selectedItem: null,
      deleteDialog: false,
      editLayer: {},
      color: null,
      fontstyles: [],
      shadow: false,
      animations: [
        { name: 'bounce', value: 'bounce' },
        { name: 'flash', value: 'flash' },
        { name: 'pulse', value: 'pulse' },
        { name: 'rubberBand', value: 'rubberBand' },
        { name: 'shakeX', value: 'shakeX' },
        { name: 'shakeY', value: 'shakeY' },
        { name: 'headShake', value: 'headShake' },
        { name: 'swing', value: 'swing' },
        { name: 'tada', value: 'tada' },
        { name: 'wobble', value: 'wobble' },
        { name: 'jello', value: 'jello' },
        { name: 'heartBeat', value: 'heartBeat' },
      ],
      alertTypes: [
        { name: 'Follower Alert', value: 'follower' },
        { name: 'Subscriber Alert', value: 'subscriber' },
        { name: 'Tip Alert', value: 'tip' },
        { name: 'Cheer Alert', value: 'cheer' },
        { name: 'Raid Alert', value: 'raid' },
      ],
    };
  },
  watch: {
    // Watch for changes in the `editLayer` object
    editLayer: {
      handler() {
        this.updateLayer();
      },
      deep: true, // Ensures nested properties are observed
    },
    fontstyles: {
      handler(newVal) {
        this.editLayer.bold = newVal.includes(0) ? 1 : 0;
        this.editLayer.italic = newVal.includes(1) ? 1 : 0;
        this.editLayer.underline = newVal.includes(2) ? 1 : 0;
      },
      deep: true,
    },
    shadow: {
      handler(newVal) {
        this.editLayer.shadow = newVal ? 1 : 0;
      },
    },
  },
  computed: {
  },
  methods: {
    selectImage(alert) {
      console.log('selectImage for', alert);
      this.$refs.mediaLibrary.open('image');
    },
    selectVideo(alert) {
      console.log('selectVideo for', alert);
      this.$refs.mediaLibrary.open('video');
    },
    hasImage(alert) {
      return (alert.image !== undefined && alert.image !== null);
    },
    hasVideo(alert) {
      return (alert.video !== undefined && alert.video !== null);
    },
    hasAudio(alert) {
      return (alert.audio !== undefined && alert.audio !== null);
    },
    getImage(alert) {
      return `@todo ${alert.image}`;
    },
    getVideoVerb(alert) {
      return this.hasVideo(alert) ? 'ändern' : 'hinzufügen';
    },
    getImageVerb(alert) {
      return !this.hasVideo(alert) ? 'ändern' : 'hinzufügen';
    },
    addAlert() {
      this.editLayer.alerts.push({
        name: 'Neuer Alert',
        type: this.alertTypes[0].value,
      });
    },
    doDeleteLayer() {
      if (this.selectedItem !== null) {
        this.$emit('delete-layer', this.selectedItem);
        this.deleteDialog = false;
        this.selectedItem = null;
      }
    },
    checkDelete() {
      this.deleteDialog = true;
    },
    refreshActiveLayer() {
      if (this.selectedItem !== null) {
        this.editLayer = { ...this.layers[this.selectedItem] };
        this.fontstyles = [];
        if (this.editLayer.bold) {
          this.fontstyles.push(0);
        }
        if (this.editLayer.italic) {
          this.fontstyles.push(1);
        }
        if (this.editLayer.underline) {
          this.fontstyles.push(2);
        }
        this.shadow = this.editLayer.shadow === 1;
      }
    },
    updateLayer() {
      if (this.selectedItem !== null) {
      // Update the corresponding layer in the `layers` array
        this.$emit('update-layer', {
          index: this.selectedItem,
          data: this.editLayer,
        });
      }
    },
    setActive(index) {
      console.log('setActive', index);
      this.selectedItem = index;
      this.refreshActiveLayer();
    },
    iconForType(type) {
      switch (type) {
        case 'alertbox':
          return 'mdi-alert-circle';
        case 'title':
          return 'mdi-format-title';
        case 'image':
          return 'mdi-image';
        case 'video':
          return 'mdi-video';
        case 'streamchat':
          return 'mdi-comment-text-outline';
        default:
          return 'mdi-help';
      }
    },
  },
};
</script>
<style scoped lang="scss">
.layer-edit {
  padding: 0 16px;

  fieldset {
    padding: 8px;
    border-radius: 8px;

    legend {
      padding: 0 4px;
    }
  }
}

.preview {
  width: 200px;
  height: 200px;
  background: url('/public/alerts/bg.png');
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
    position: relative;
    top: 50%;
    left: 50%;
  }
}
</style>
